import {Component} from "@angular/core";
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: "dah-404",
    imports: [TranslateModule],
    templateUrl: "./page-not-found.component.html"
})

export class PageNotFoundComponent {

    goBack() {
        window.history.back();
    }
}
